// extracted by mini-css-extract-plugin
module.exports = {"SearchIcon":"Search_SearchIcon__1JsL9","Input":"Search_Input__nFwq4","Search":"Search_Search__1x9z8"};